module.exports = __webpack_public_path__ + "static/media/indy137.ab56272c.usdz";